import { put, takeEvery, call, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import { NotificationsConstants } from "../constants/notifications.constants";
import {
    fetchNotifications,
    fetchNotificationsFailure,
    fetchNotificationsSuccess,
    setViewedAt,
    setViewedAtFailure,
    setViewedAtSuccess,
    setOpenedAtSuccess,
    setOpenedAtFailure
} from "../actions/notifications.actions";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import { graphQLNotificationContents } from "./query.helper";

export function* requestOpenNotifications() {
    yield takeEvery(
        NotificationsConstants.OPEN_NOTIFICATIONS_POPOVER,
        doOpenPopover
    );
}

function* doOpenPopover() {
    yield put(fetchNotifications());
}

export function* requestNotifications() {
    yield takeEvery(
        NotificationsConstants.FETCH_NOTIFICATIONS,
        doRequestNotifications
    );
}

function* doRequestNotifications({ payload }) {
    payload = payload || {};
    let first = payload.first || 5;
    let after = payload.after || "";
    let replace = payload.replace || false;
    try {
        const query = `{
                notifications(
                    first: ${first}
                    after: ${JSON.stringify(after)}
                ) ${graphQLNotificationContents(false)}
            }`;
        const results = yield call(doGraphQLQuery, query);
        yield put(fetchNotificationsSuccess({ ...results, replace }));

        const {
            open,
            pathname
        } = yield select(
            ({
                router: { location: { pathname } },
                notifications: { open }
            }) => ({
                open,
                pathname
            })
        );

        if (open || pathname === "/notifications") {
            yield put(setViewedAt());
        }
    } catch (e) {
        yield call(handleFailure, e, fetchNotificationsFailure);
    }
}

export function* setViewedAtFlow() {
    yield takeEvery(NotificationsConstants.SET_VIEWED_AT, doSetViewedAt);
}

function* doSetViewedAt() {
    try {
        let edges = yield select(
            ({ notifications: { notificationsPagedRequest: { edges } } }) =>
                edges
        );
        edges = edges
            .filter(e => !e.node.viewedAtDate)
            .map(e => e.node.id)
            .toArray();

        if (edges.length > 0) {
            const query = `mutation {
                updateNotificationViewed(ids: ${JSON.stringify(edges)}) {
                    id
                }
            }`;
            yield call(doGraphQLQuery, query);
            yield put(setViewedAtSuccess());
        }
    } catch (e) {
        yield call(handleFailure, e, setViewedAtFailure);
    }
}

export function* setOpenedAtFlow() {
    yield takeEvery(NotificationsConstants.SET_OPENED_AT, doSetOpenedAt);
}

function* doSetOpenedAt({ payload }) {
    const id = payload && payload.id;
    try {
        let edges = yield select(
            ({ notifications: { notificationsPagedRequest: { edges } } }) =>
                edges
        );
        edges = edges
            .filter(e => !e.node.openedAtDate && e.node.postId === id)
            .map(e => e.node.id)
            .toArray();

        if (edges.length > 0) {
            const query = `mutation {
                updateNotificationOpened(ids: ${JSON.stringify(edges)}) {
                    id
                }
            }`;
            yield call(doGraphQLQuery, query);
            yield put(setOpenedAtSuccess({ id }));
        }
    } catch (e) {
        yield call(handleFailure, e, setOpenedAtFailure);
    }
}

const initialDelay = 1000 * 60;

export function* pollForNotifications() {
    let delayMS = initialDelay;
    while (true) {
        yield delay(delayMS);
        try {
            let {
                apiToken,
                edges
            } = yield select(
                ({
                    userSettings: { apiToken },
                    notifications: { notificationsPagedRequest: { edges } }
                }) => {
                    return { apiToken, edges };
                }
            );
            if (apiToken) {
                const query = `{
                    notifications(
                        first: 1
                    ) {
                        pageInfo {
                            endCursor
                        }
                    }
                }`;
                const {
                    notifications: { pageInfo: { endCursor } }
                } = yield call(doGraphQLQuery, query);
                if (endCursor && !edges.find(e => e.cursor === endCursor)) {
                    delayMS = initialDelay;
                    yield put(fetchNotifications());
                }
            } else {
                delayMS = initialDelay;
            }
        } catch (e) {
            console.log(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/notifications.saga.js